import React from 'react'

interface IProps {
    SquareSize: number;
    StrokeWidth: number;
    ProgresValue: number;
    circleBackground: string;
    StatusLabel: string;
    Icon: any;
    circleProgressColor: string;
    Value: number;
    IsFilterActive: boolean;
    OnClickBar: () => void;
    circleBackgroundHover?: boolean;
}

interface State {
}

export const CircularBarChat: React.FC<IProps> = (props: IProps) => {

    // constructor(props) {
    //     super(props)
    //     this.state = {
    //     }
    // }

    const onClickBar = () => {
        props.OnClickBar()
    }

    // render() {
    const radius = (props.SquareSize - props.StrokeWidth) / 2;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - dashArray * props.ProgresValue / 100;
    return (
        <div className={`flex-direction d-flex justify-between `} >
            <svg
                width={props.SquareSize}
                height={props.SquareSize}
                className={`${props.circleBackgroundHover ? "circle-background" : "circle-background-mobile"} ${props.Value == 0 ? "" : "c-pointer"} ${props.IsFilterActive ? "circle-background-active-shadow" : ""}`}
                style={{ borderRadius: "50%" }}
                onClick={onClickBar}
            >
                <circle
                    className={` ${props.circleBackground} ${props.IsFilterActive ? "circle-background-active" : ""}`}
                    cx={props.SquareSize / 2}
                    cy={props.SquareSize / 2}
                    r={radius}
                    strokeWidth={`${props.StrokeWidth}px`} />

                <circle
                    className={`circle-progress ${props.circleProgressColor}`}
                    cx={props.SquareSize / 2}
                    cy={props.SquareSize / 2}
                    r={radius}
                    strokeWidth={`${props.StrokeWidth}px`}
                    transform={`rotate(-90 ${props.SquareSize / 2} ${props.SquareSize / 2})`}
                    style={{
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashOffset
                    }} />

                <text
                    className="circle-text"
                    x="50%"
                    y="50%"
                    dy=".3em"
                    textAnchor="middle">
                    {`${props.Value}`}
                </text>
            </svg>

            <div className='p-1 mx-auto'>
                <>{props.Icon}</>
                <span className='h4-regular color-circular-bar-circle-status-label'>{props.StatusLabel}</span>
            </div>

        </div >
    )
    // }
}
